import { UPGRADES } from '../data/upgrades'
import type { OnChainPlayerState } from '../chain/player'
import type { OnChainRunState } from '../chain/run'

// Cached on-chain state
let cachedPlayer: OnChainPlayerState | null = null
let cachedRun: OnChainRunState | null = null

export function cachePlayerState(ps: OnChainPlayerState): void {
  cachedPlayer = ps
}

export function getCachedPlayerState(): OnChainPlayerState | null {
  return cachedPlayer
}

export function cacheRunState(rs: OnChainRunState | null): void {
  cachedRun = rs
}

export function getCachedRunState(): OnChainRunState | null {
  return cachedRun
}

// Convenience accessors that read from cached chain state

export function getCash(): number {
  return Number(cachedPlayer?.cash ?? 0n)
}

export function getUpgradeLevel(id: 'drill' | 'fuelTank' | 'cargo' | 'negotiator' | 'luck'): number {
  if (!cachedPlayer) return 0
  switch (id) {
    case 'drill': return cachedPlayer.drillLevel
    case 'fuelTank': return cachedPlayer.fuelTankLevel
    case 'cargo': return cachedPlayer.cargoLevel
    case 'negotiator': return cachedPlayer.negotiatorLevel
    case 'luck': return cachedPlayer.luckLevel
  }
}

export function getFuelCapacity(): number {
  const level = getUpgradeLevel('fuelTank')
  return UPGRADES.fuelTank.levels[level].capacity
}

export function getCargoCapacity(): number {
  const level = getUpgradeLevel('cargo')
  return UPGRADES.cargo.levels[level].capacity
}

export function getDrillFuelMultiplier(): number {
  const level = getUpgradeLevel('drill')
  return UPGRADES.drill.levels[level].fuelMultiplier
}

export function getSellMultiplier(): number {
  const level = getUpgradeLevel('negotiator')
  return UPGRADES.negotiator.levels[level].priceMultiplier
}

export function getLuckMultiplier(): number {
  const level = getUpgradeLevel('luck')
  return UPGRADES.luck.levels[level].rarityMultiplier
}
